var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandGoogleChromeStyleBrand = function SvgBrandGoogleChromeStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandGoogleChromeStyleBrand__clip0_3952_114114)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#229342",
    d: "M6.804 15 1.608 6.003A11.997 11.997 0 0 0 12.001 24l5.196-9A5.998 5.998 0 0 1 6.804 15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBC116",
    d: "m17.196 15-5.195 9A11.997 11.997 0 0 0 22.39 6H11.999a6 6 0 0 1 5.197 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M12 16.751a4.75 4.75 0 1 0 0-9.5 4.75 4.75 0 0 0 0 9.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E33B2E",
    d: "M12 6h10.391a12 12 0 0 0-20.783.002L6.804 15h.001a6 6 0 0 1 5.196-9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandGoogleChromeStyleBrand__clip0_3952_114114"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandGoogleChromeStyleBrand);
export { ForwardRef as ReactComponent };